export default __webpack_public_path__ + "awakening.mp3";